import { DisplayedCurrency } from '@coin/shared/core/util-enums';

export class SetMeritCurrency {
  static readonly type = '[Merit Currency] Set Currency';
  constructor(public readonly payload: DisplayedCurrency) {}
}
